<template>
  <div class="m-chips" role="tablist">
    <button
      v-for="chip in items"
      :key="chip.key"
      type="button"
      role="tab"
      class="m-chip"
      :class="{ 'is-active': chip.active }"
      :aria-selected="chip.active ? 'true' : 'false'"
      @click="$emit('select', chip)"
    >
      <i v-if="chip.icon" :class="['fas', 'fa-' + chip.icon]" aria-hidden="true"></i>
      <span>{{ chip.label }}</span>
      <i v-if="chip.locked" class="fas fa-lock m-chip__lock" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
/** Pastillas que se deslizan de costado (reportes, vistas). items: [{ key, label, icon, active, locked }]. */
export default {
  name: "MobileChips",
  props: {
    items: { type: Array, default: () => [] },
  },
  watch: {
    items() {
      this.$nextTick(this.scrollActiveIntoView);
    },
  },
  mounted() {
    this.scrollActiveIntoView();
  },
  methods: {
    scrollActiveIntoView() {
      const el = this.$el && this.$el.querySelector(".m-chip.is-active");
      if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest", inline: "center" });
    },
  },
};
</script>

<style scoped>
.m-chips {
  display: flex;
  gap: 0.4rem;
  overflow-x: auto;
  padding: 0.35rem 0 0.15rem;
  scrollbar-width: none;
}
.m-chips::-webkit-scrollbar {
  display: none;
}
.m-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 14rem;
  height: 2.1rem;
  padding: 0 0.85rem;
  border: 1px solid var(--m-border);
  border-radius: 999px;
  background: var(--m-surface);
  color: var(--m-muted);
  font-size: 0.85rem;
  white-space: nowrap;
}
.m-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
}
.m-chip.is-active {
  border-color: var(--bs-primary);
  background: rgba(var(--bs-primary-rgb), 0.12);
  color: var(--bs-primary);
  font-weight: 600;
}
.m-chip__lock {
  font-size: 0.7rem;
  opacity: 0.7;
}
</style>
